export const defaultProductUi = {
  minusDisabled: true,
  plusDisabled: false,
  quantity: 1,
  canAddMore: true,
  fullPrice: 0.00,
  salePrice: 0.00,
  backorder: null, 
  errors: [],
};


export function formatBackorderMessage(requestedQuantity, availableQuantity, productAllowsBackordering = false, productType = "") {
  const desiredQuantity = parseInt(requestedQuantity, 10);
  const currentQuantity = parseInt(availableQuantity, 10);

  if (isNaN(desiredQuantity) || isNaN(currentQuantity)) {
    return null;
  }

  const backorderQuantityNeeded = desiredQuantity - currentQuantity;
  if (productAllowsBackordering === true && productType !== window.gettext("Digital Downloads") && backorderQuantityNeeded > 0) {
    return backorderQuantityNeeded + window.gettext(" on backorder");
  } 

  return null;
}


export function updateProductUi(product, newQuantity, productUi) {
  const {price, sale_price, retail_price, quantity_break_ranges, quantity, quantity_in_cart, quantity_break_prices} = product;
  const parsedQuantity = parseInt(newQuantity, 10);

  let salePrice = sale_price || price;
  let fullPrice = retail_price || price;
  let backorder;
  if ( quantity_break_ranges.length > 0) {
    for (let i = 0; i < quantity_break_ranges.length; i++) {
      const range = quantity_break_ranges[i].split("-");
      const lowerBound = parseInt(range[0], 10);
      const upperBound = parseInt(range[1], 10);
      if (
        (parsedQuantity >= lowerBound && parsedQuantity <= upperBound) ||
        (parsedQuantity >= lowerBound && isNaN(upperBound))
      ) {
        salePrice = quantity_break_prices[i];
        break;
      } 
    }
  }


  // product.manage_stock is False if a product is backorderable, on_demand, or downloadable.
  // if (product.backordering === true && product.type !== window.gettext("Digital Downloads")) {
  backorder = formatBackorderMessage(parsedQuantity + quantity_in_cart, quantity, product.backordering, product.type); 
  // } else {
  //   backorder = null;
  // }


  return {
    ...productUi,
    quantity: parseInt(newQuantity),
    minusDisabled: parsedQuantity <= product.minimum_quantity,
    backorder: backorder,
    plusDisabled: (product.maximum_quantity !== null) && (parsedQuantity >= product.max_remaining),
    canAddMore: product.maximum_quantity === null || product.max_remaining > 0,
    salePrice: parseFloat(salePrice),
    fullPrice: parseFloat(fullPrice),
  }
}


